export default __webpack_public_path__ + "static/media/slide-1.64599f03.jpeg";